export default {
    palette: {
        primary: {
            light: '#BBEAF1',
            main: '#33C2D5',
            dark: '#019EAC',
            contrastText: '#fff',
        },
        secondary: {
            light: '#6ec6ff',
            main: '#2E3033',
            dark: '#0069c0',
            contrastText: '#fff',
        },
    },
    typography: {
        title: {
            fontWeight: 400,
        },
        fontFamily: [
            'DINRegular',
            'Roboto',
            'Arial',
            'sans-serif',
        ]
    },
    overrides: {
        MuiCard : {
            root: {
              overflow : 'visible',
              width : '100%'
            },
        },
    },
};
